/*
  Ad click attribution for sign-ups. A tracker campaign sends visitors to the
  marketing site with ?xcid=<click id>; the site passes it on to the sign-up
  page. We keep it for 30 days and send it with POST /auth/register, so the
  backend can credit the registration (and a later payment) to that click.
  See backend/signup_attribution.py.
*/

const KEY = 'xp_signup_click';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;
const VALID = /^[A-Za-z0-9_-]{6,64}$/;

export function captureSignupClickId(search) {
  try {
    const query = search === undefined ? window.location.search : search;
    const value = new URLSearchParams(query).get('xcid');
    if (value && VALID.test(value)) {
      localStorage.setItem(KEY, JSON.stringify({ id: value, at: Date.now() }));
    }
  } catch (e) {
    // Storage disabled: attribution is best effort.
  }
}

export function signupClickId() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const saved = JSON.parse(raw);
    if (!saved || !VALID.test(String(saved.id)) || Date.now() - Number(saved.at) > TTL_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return saved.id;
  } catch (e) {
    return null;
  }
}

if (typeof window !== 'undefined') captureSignupClickId();
